import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
import { legalDocuments, type LegalDocument } from '../data/legal';
type FooterProps = {
  brand?: string;
  disclaimer?: string;
  documents?: LegalDocument[];
};
const DEFAULT_DISCLAIMER = 'Este material es educativo y de entrenamiento físico. No sustituye la evaluación ni el consejo de un profesional de la salud. Consulta a tu médico antes de comenzar cualquier programa de ejercicio. Los resultados varían según cada persona y su constancia.';
export function Footer({
  brand = 'Glute Lab',
  disclaimer = DEFAULT_DISCLAIMER,
  documents = legalDocuments
}: FooterProps) {
  const [activeDoc, setActiveDoc] = useState<LegalDocument | null>(null);
  return <footer className="w-full bg-coal-deep" data-id="element-8" data-mp="3qc41f9dfhwkl">
      <div className="mx-auto w-full max-w-3xl px-5 pb-12 pt-10 text-center sm:px-6 sm:pt-12" data-id="element-9" data-mp="3qf9nsguoakcm">
        <p className="text-base font-bold uppercase tracking-tight text-white sm:text-lg" data-id="element-10" data-mp="2a1jjb8zn5u2g">
          {brand}
        </p>
        <p className="mx-auto mt-3 max-w-xl text-[0.8rem] leading-relaxed text-white/40 sm:mt-4 sm:text-sm" data-id="element-11" data-mp="3l9abve5p2w2b">
          {disclaimer}
        </p>

        <nav aria-label="Enlaces legales" className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 sm:mt-6" data-id="element-12" data-mp="3gc0ffejw1k4z">
          {documents.map((doc, index) => <React.Fragment key={doc.id} data-id="element-13" data-mp="3q726wh1myyaq" data-mpi={index}>
              {index > 0 && <span className="text-white/20" aria-hidden="true" data-id="element-14" data-mp="81ywcgswhu2x">
                  ·
                </span>}
              <button type="button" onClick={() => setActiveDoc(doc)} className="rounded text-[0.8rem] font-medium text-white/60 underline underline-offset-4 outline-none transition-colors duration-150 ease-smooth hover:text-ember focus-visible:ring-2 focus-visible:ring-ember sm:text-sm" data-id="element-15" data-mp="33e3x3jw4ep1">
                {doc.label}
              </button>
            </React.Fragment>)}
        </nav>

        <p className="mt-5 text-[0.7rem] text-white/25 sm:mt-6 sm:text-xs" data-id="element-16" data-mp="tvmnzb2xs4iq">
          © {new Date().getFullYear()} {brand}. Todos los derechos reservados.
        </p>
      </div>

      <LegalModal document={activeDoc} onClose={() => setActiveDoc(null)} data-id="element-17" data-mp="13taji38d9g1y" />
    </footer>;
}